var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7084_47071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 15.8279L5.03079 14.2938C5.25263 14.1957 5.36355 14.1466 5.46732 14.0826C5.5595 14.0257 5.64737 13.96 5.73003 13.8862C5.82308 13.8032 5.90711 13.7066 6.07517 13.5133L13.125 5.40598C13.8154 4.61207 13.8154 3.32489 13.125 2.53098C12.4347 1.73707 11.3154 1.73707 10.625 2.53098L3.57518 10.6383C3.40711 10.8316 3.32308 10.9282 3.25087 11.0352C3.18673 11.1302 3.12963 11.2313 3.08015 11.3373C3.02444 11.4566 2.98178 11.5842 2.89646 11.8393L1.5625 15.8279ZM1.5625 15.8279L2.84883 11.9818C2.94087 11.7066 2.9869 11.569 3.06584 11.5059C3.13482 11.4508 3.22019 11.43 3.30268 11.4481C3.39708 11.4689 3.48774 11.5731 3.66905 11.7816L5.08098 13.4053C5.2623 13.6139 5.35295 13.7181 5.37098 13.8267C5.38673 13.9215 5.36862 14.0197 5.32072 14.099C5.2659 14.1898 5.14624 14.2427 4.90692 14.3486L1.5625 15.8279Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7084_47071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17.25,
    fill: "white",
    transform: "translate(0 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAlt);
export default __webpack_public_path__ + "static/media/pencil-alt.f44e102154665bec2f521e7d359d1b1e.svg";
export { ForwardRef as ReactComponent };